shadow$provide[312] = function(require,module,exports) {
var require$_DOT__SLASH_shader_DOT_js = require("./shader.js");
require.exportCopy(module, require$_DOT__SLASH_shader_DOT_js);

};